// Color/spacing tokens for the Solutions page's own design system — a
// distinct palette (rust orange + charcoal, 8px button radius) supplied via
// an exact reference mockup, kept separate from the site-wide pbdqTokens
// (navy + brand orange, pill buttons) used by every other page so this
// doesn't change Home or any other page's look.
export const sdsColors = {
    bg: '#FFFFFF',
    heroBg: 'radial-gradient(70% 90% at 86% 10%, #DCE7F3 0%, rgba(220, 231, 243, 0) 60%), linear-gradient(180deg, #F6F8FB 0%, #FFFFFF 100%)',
    surface: '#FFFFFF',
    text: '#1B2430',
    textMuted: '#5B6470',
    textSubtle: '#6B7280',
    border: '#E1E4E9',
    borderLight: '#EEF1F4',
    // Warm peach border for cards that sit on a tinted (#FDECE3) background
    borderWarm: '#F5D9C8',
    tint: '#FBEDE4',
    accent: '#ED6628',
    accentDark: '#D5581D',
    accentDeep: '#A63C0C',
    check: '#ED6628',
    imagePlaceholder: '#F4F3F1',
    successBg: '#F0F5E1',
    successText: '#4A7A1F',
    soonBg: '#FBF8D8',
    soonText: '#6B5D1C',
    navy: '#1B2430',
    navyPanel: '#172939',
    navLinkInactive: '#5B6470',
    navLinkActive: '#ED6628',
};

export const sdsRadius = {
    sm: '8px',
    md: '12px',
    pill: '999px',
};

// Category accents in wheel order (Sky, Lime, Gold, Orange, Magenta), one
// per solution, each with a matching soft tint for its badge/tag background.
export const SDS_RAILS = [
    { rail: '#3CC6F3', tint: '#E0F5FD' },
    { rail: '#B7D334', tint: '#F1F7DC' },
    { rail: '#F8B143', tint: '#FEF1DC' },
    { rail: '#ED6628', tint: '#FDECE3' },
    { rail: '#C91C6E', tint: '#F8E4EE' },
];

// The 8-swatch gradient stripe under the header / above the footer.
export const SDS_STRIPE = ['#3CC6F3', '#EEE921', '#B7D334', '#F8B143', '#ED6628', '#C91C6E', '#EA4E99', '#6A8EC9'];

// Shared button look (8px radius) — an object spread into each file's own
// makeStyles so both stay visually identical without a second runtime
// style-sheet dependency. Height/font-size match the site's own established
// button sizing (44px / 18px), not the reference mockup's smaller 40px/14px.
export const sdsBtnBase = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    height: 44,
    padding: '0 22px',
    boxSizing: 'border-box',
    borderRadius: sdsRadius.sm,
    fontFamily: 'inherit',
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1,
    textDecoration: 'none',
    cursor: 'pointer',
    border: '1px solid transparent',
    whiteSpace: 'nowrap',
    transition: 'background-color 120ms, border-color 120ms, color 120ms',
};
